import React from 'react'
import { faBug,faDisease ,faLeaf,faPlantWilt,faList} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BellFilled  } from "@ant-design/icons";
import { useGetUnViewedNotificationsQuery } from 'api/observedCropApi';
import { Badge } from 'antd';


export const DiseaseIcon = () => {
  return (
    <FontAwesomeIcon icon={faDisease} />
  )
}

export const BellFilledIcon = () => {
  const storedUser = JSON.parse(localStorage.getItem('user'));
  const unViewedNotification = useGetUnViewedNotificationsQuery(storedUser?.uId);
  return (
    <Badge  style={{backgroundColor: '#1DA1F2' }} dot={unViewedNotification?.data?.length > 0 ? true : false}>
        <BellFilled/>
  </Badge>

  )
}

export const PestIcon = () => {
    return (
      <FontAwesomeIcon icon={faBug} />
    )
  }


  export const WeedIcon = () => {
    return (
        <FontAwesomeIcon icon={faLeaf} />
    )
  }


  export const CropIcon = () => {
    return (
      <FontAwesomeIcon icon={faPlantWilt} />
  )
  }


 
  
  export const ListIcon =  () => {
      return (<FontAwesomeIcon icon={faList} />);
  }